export function observeLCP() {
  try {
    const po = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        // @ts-ignore
        const el = (entry as any).element as Element | undefined;
        // eslint-disable-next-line no-console
        console.log('[LCP]', Math.round(entry.startTime), 'ms', el?.tagName, (el as any)?.id, (el as any)?.className);
      }
    });
    // @ts-ignore
    po.observe({ type: 'largest-contentful-paint', buffered: true });
  } catch {}
}


